import clsx from "clsx";
import { Menu as AriaMenu, MenuItem as AriaMenuItem } from "react-aria-components";

import type { MenuItem, MenuProps } from "@/components/ui/Menu/Menu";

export type MenuListProps = Pick<MenuProps, "items"> & {
  onItemClick?: (item: MenuItem) => void;
  className?: string;
};

export const MenuList = ({ items, onItemClick, className }: MenuListProps) => {
  const handleItemAction = (item: MenuItem) => {
    if (onItemClick) {
      // Use custom click handler if provided
      onItemClick(item);
    } else {
      // Default behavior: execute the item's onAction
      item.onAction?.();
    }
  };

  return (
    <AriaMenu className={clsx("focus-visible:!outline-hidden! h-full outline-hidden!", className)}>
      {items.map(({ label, content, ...item }) => (
        <AriaMenuItem
          key={label}
          {...item}
          textValue={label}
          aria-label={label}
          onAction={() => handleItemAction({ label, content, ...item })}
          className={clsx(
            "flex cursor-pointer items-center justify-start gap-2 px-list-side-item py-list-height-item",
            "outline-hidden",
            "first:rounded-t-xl",
            "first:pt-4",
            "text-text-default-1",
            "border-elevation-outline-default-1 border-b",
            "hover:text-neutral-100",
            "focus-visible:bg-neutral-400 focus-visible:text-neutral-100",
            item.className,
          )}
        >
          {content}
        </AriaMenuItem>
      ))}
    </AriaMenu>
  );
};
